import { render, staticRenderFns } from "./FundsTable.vue?vue&type=template&id=7b41bfea&"
import script from "./FundsTable.vue?vue&type=script&lang=js&"
export * from "./FundsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports